import React from 'react';

import { HomeCard } from '@components/HomeCard';
import { SectionWrapper } from '@components/SectionWrapper';
import { WoodBackground } from '@components/WoodBackground';

export const Home = () => (
  <SectionWrapper background={<WoodBackground />}>
    <HomeCard />
  </SectionWrapper>
);
